import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import MainLayout from "../components/layout";
import Rate from "../pages/rate";
import Thankyou from "../pages/thankyou";
import FacialRecognition from "../pages/facial-recognition";
import { useLocation } from "react-router-dom";

const Router = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <Routes>
      <Route path="/" element={<FacialRecognition />} />
      <Route path="/" element={<MainLayout />}>
        <Route path="/rate" element={<Rate />} />
        <Route path="/thankyou" element={<Thankyou />} />
      </Route>
    </Routes>
  );
};
export default Router;
